import { useCallback } from 'react'
import moment from 'moment/moment'
import { useDomainMessages } from 'domains/shifts/utils/domain/intl'
import {
  type DayOfWeekOption,
  RepeatShiftEnum,
  type RepeatShiftOption,
} from './recurringShift.types'

export const usePartnerPickRecurringShiftFormOptions = (date: string) => {
  const messages = useDomainMessages(
    {
      newShiftTitle: 'shiftsDomain.prompt.newShift',
      editShiftTitle: 'shiftsDomain.prompt.editShift',
      from: 'shiftsDomain.prompt.from',
      to: 'shiftsDomain.prompt.to',
      repeatShift: 'shiftsDomain.prompt.repeatShift',
      repeatsOn: 'shiftsDomain.prompt.repeatsOn',
      cancel: 'shiftsDomain.prompt.cancel',
      save: 'shiftsDomain.prompt.save',
      doesNotRepeat: 'shiftsDomain.prompt.doesNotRepeat',
      weeklyOnDay: 'shiftsDomain.prompt.weeklyOnDay',
      everyWeekday: 'shiftsDomain.prompt.everyWeekday',
      daily: 'shiftsDomain.prompt.daily',
      custom: 'shiftsDomain.prompt.custom',
      noEndDate: 'shiftsDomain.prompt.noEndDate',
      endsOn: 'shiftsDomain.prompt.endsOn',
      delete: 'shiftsDomain.prompt.delete',
      sunday: 'shiftsDomain.prompt.sunday',
      monday: 'shiftsDomain.prompt.monday',
      tuesday: 'shiftsDomain.prompt.tuesday',
      wednesday: 'shiftsDomain.prompt.wednesday',
      thursday: 'shiftsDomain.prompt.thursday',
      friday: 'shiftsDomain.prompt.friday',
      saturday: 'shiftsDomain.prompt.saturday',
    },
    {
      dayOfWeek: moment(date).format('dddd'), // ex. Monday,
    }
  )

  const repeatShiftOptions: RepeatShiftOption[] = [
    { label: messages.doesNotRepeat, value: RepeatShiftEnum.DoesNotRepeat },
    { label: messages.weeklyOnDay, value: RepeatShiftEnum.WeeklyOnDay },
    { label: messages.everyWeekday, value: RepeatShiftEnum.EveryWeekday },
    { label: messages.daily, value: RepeatShiftEnum.Daily },
    { label: messages.custom, value: RepeatShiftEnum.Custom },
  ]

  const daysOfWeekOptions: DayOfWeekOption[] = [
    { label: messages.monday, value: 1 },
    { label: messages.tuesday, value: 2 },
    { label: messages.wednesday, value: 3 },
    { label: messages.thursday, value: 4 },
    { label: messages.friday, value: 5 },
    { label: messages.saturday, value: 6 },
    { label: messages.sunday, value: 0 },
  ]

  const getDayOfWeekOptionForDate: (d: string) => DayOfWeekOption = useCallback(
    d => ({ label: moment(d).format('dddd'), value: 5 }),
    []
  )

  //https://stackoverflow.com/questions/31183558/moment-js-how-to-get-day-of-week-number
  const _dayOffset = date => moment(date).isoWeekday() % 7

  const getDaysOfWeekFromRepeatType = (
    repeatType: RepeatShiftEnum,
    day: string
  ): DayOfWeekOption[] => {
    if (repeatType === RepeatShiftEnum.WeeklyOnDay) {
      return daysOfWeekOptions.filter(option => option.value === _dayOffset(day))
    }
    if (repeatType === RepeatShiftEnum.EveryWeekday) {
      return daysOfWeekOptions.filter(option => ![0, 6].includes(option.value))
    }
    if (repeatType === RepeatShiftEnum.Daily) {
      return daysOfWeekOptions
    }
    return [] //RepeatShiftEnum.DoesNotRepeat
  }

  return {
    repeatShiftOptions,
    daysOfWeekOptions,
    getDayOfWeekOptionForDate,
    getDaysOfWeekFromRepeatType,
  }
}
